import {createFileRoute} from '@tanstack/react-router'
import {WalletWithdraw} from "@/components/wallet/WalletWithdraw/WalletWithdraw.tsx"

export const Route = createFileRoute('/_mainLayout/wallet/withdraw/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <WalletWithdraw/>
}
